var React = require('react');

function StarInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\t.st0 {\n\t\t\tstroke-width: 30;\n\t\t\tstroke-miterlimit: 30;\n\t\t}\n\t"),React.createElement("path",{"className":"st0","d":"M-481.8,54.5l-62.1,125.9l-138.9,20.3c-24.9,3.6-34.9,34.3-16.8,51.9l100.5,97.9l-23.8,138.4\n\tc-4.3,25,22.1,43.7,44.1,32l124.3-65.3l124.3,65.3c22.1,11.6,48.4-7,44.1-32l-23.8-138.4l100.5-97.9c18.1-17.6,8.1-48.3-16.8-51.9\n\tl-138.9-20.3l-62.1-125.9C-438.3,32-470.6,31.7-481.8,54.5z","key":1})]);
}

StarInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"-710.5 25 512 512","style":{"enableBackground":"new -710.5 25 512 512"},"xmlSpace":"preserve"};

module.exports = StarInline;

StarInline.default = StarInline;
